export default "__VITE_ASSET__4ce2b1a2__"